<template>
  <tr class="draggable">
    <td class="draggable-handle"> {{ configData.milestone_category_name }} </td>
    <td class="draggable-handle"> {{ configData?.delay_value }} {{ translateFrequency(configData.delay_unit) }} </td>
    <td class="draggable-handle"> <span class="badge badge-light-primary"> {{ configData.milestone_categories_progress }} % </span> </td>
    <td class="draggable-handle"> <span class="badge badge-primary"> {{ configData.status?.length.toString().padStart(2, '0') }} </span> </td>
    <td class="draggable-handle"> <span class="badge badge-primary"> {{ configData.tasks?.length.toString().padStart(2, '0') }} </span> </td>
    <td class="draggable-handle">
      <span class="badge badge-primary">
        <img src="/assets/media/tasks/review_white.png" class="h-15px me-2" alt="review">
      {{ taskNeedReviews.toString().padStart(2, '0') }}
      </span>
    </td>
    <td class="draggable-handle w-100px">
      <a @click.prevent="updateRowStepOrder" class="btn btn-sm btn-clean btn-icon" :title="$t('button.orderStatus')"><i class="fas fa-sort-numeric-down fs-2"></i></a>
      <a @click.prevent="updateStepTasks" class="btn btn-sm btn-clean btn-icon" :title="$t('button.addDefaultTask')"><i class="fas fa-plus fs-2"></i></a>
      <a @click.prevent="updateStep" class="btn btn-sm btn-clean btn-icon" :title="$t('button.edit')"><i class="fas fa-edit fs-2"></i></a>
      <a @click.prevent="deleteRow" class="btn btn-sm btn-clean btn-icon" :title="$t('button.delete')"><i class="fas fa-trash fs-2"></i></a>
    </td>
  </tr>

  <OrderStatusModal :id="'reorder_status'+index" :status="[...configData.status]" @save="handleStatusSave"  />
  <StepSelectionForm :id="'selection_step'+index" :form="configData" @save="handleStepSave" :selectedSteps="selectedSteps"  />
  <TaskModelModal :id="'add_default_task'+index" :data="[...configData.tasks]" @save="handleDefaultTaskSave"/>

</template>

<script setup>

import {computed, defineEmits, defineProps, ref, watch} from "vue";
import {useStore} from "vuex";
import OrderStatusModal from "@/Modules/Projects/components/ProjectType/OrderStatusModal.vue";
import TaskModelModal from "@/Modules/Projects/components/ProjectType/TaskModelModal.vue";
import {useLocales} from "@/composables/locales";
import StepSelectionForm from "@/Modules/Projects/components/ProjectType/StepSelectionForm.vue";

const {locale} = useLocales()
const store = useStore()
const emits = defineEmits(["deleteConfig"])

const props = defineProps({
  config: {
    type: Object,
    default: () => ({
      position: 0,
      milestone_category_id: '',
      milestone_category_name: '',
      delay_value: '',
      delay_unit: '',
      milestone_categories_progress: '',
      status: [],
      tasks: [],
    })
  },
  index: Number,
  selectedSteps: {type: Array, default: () => ([])}
})

const configData = ref(props.config)

const frequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

const taskNeedReviews = computed(() => {
  if(!configData.value) return 0;
  if(configData.value.tasks && configData.value.tasks.length > 0) {
    return configData.value.tasks.filter(task => task.need_review).length
  }
  return 0
})

watch(() => props.config, (val) => {
 configData.value =  props.config
})


function translateFrequency(freq) {
  let frequency = frequencyEnum.value?.find(el => el.value === freq);
  return frequency ? frequency[locale.value] : ''
}

function updateStepTasks() {
  $('#add_default_task'+props.index).modal('toggle')
}

function updateRowStepOrder() {
  $('#reorder_status'+ props.index).modal('toggle')
}

function updateStep() {
  $('#selection_step'+ props.index).modal('toggle')
}

function deleteRow(index) {
  emits('deleteConfig', props.index)
}

function handleStatusSave(data) {
  configData.value.status = [...data]
}

function handleDefaultTaskSave(data) {
  configData.value.tasks = data
}

function handleStepSave(data) {
  configData.value = data
}


</script>

<style scoped>

</style>